import { createRequire } from 'node:module';
import { dirname, join, relative } from 'node:path';
import { outdent } from 'outdent';
import { outputFile, writeJson } from '@wix/cli-fs';
import { skillDocs } from './skills-docs.js';

export const agentConfigsTaskText = {
  loadingText: 'Generating agent configuration files...',
  successText: 'Agent configuration files generated!',
};

export async function generateAgentConfigs(packageFolder: string) {
  try {
    const require = createRequire(join(packageFolder, 'package.json'));
    const cliPackagePath = require.resolve('@wix/cli/package.json');
    const cliAgentsAbsolutePath = join(
      dirname(cliPackagePath),
      'agents',
      'instructions.md'
    );
    const cliAgentsPath = relative(packageFolder, cliAgentsAbsolutePath);

    const agentsMdContent = outdent`
      ## CLI Commands

      All CLI instructions can be found at:
      ${cliAgentsPath}

      ${skillDocs}
    `;

    await outputFile(join(packageFolder, 'AGENTS.md'), agentsMdContent);
    await writeJson(
      join(packageFolder, '.gemini', 'settings.json'),
      { contextFileName: 'AGENTS.md' },
      { spaces: 2 }
    );
    await outputFile(join(packageFolder, 'CLAUDE.md'), '@AGENTS.md');
  } catch {
    // Agent config generation is not critical, continue without it
  }
}
